import React, {useState, useEffect, Fragment, useContext} from 'react';
import localization from 'assets/localization/localization';
import Loader from 'components/sales/Loader/loader';
import PanelCardWithHeading from "../../../components/tickets/panelCardWithHeading";
import TableSection from "../../../components/sales/tableSection/tableSection";
import Layout from 'components/sales/layout/layout';
import queryString from 'query-string';
import {Button} from "react-bootstrap";
import $ from "jquery";
import CustomModal from "../../valetServices/modal";
import {getVendorPaymentRequestList} from "../../../services/redux/sales/vendorPortal/action";
import Images from "../../../assets/images/imageData";
import ModalPop from "../../../components/sales/modal/modal";
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

const AssignmentForm = ({
                         reportee = [],
                         location,
                         searchInfo = [],
                         getVendorPaymentRequestList,
                         dataList,
                         approveHoldRequest,
                         history
     }) => {
    const [listData, setListData] = useState();
    const [siteIds, setSiteIds] = useState([]);
    const [isAllChecked, setIsAllChecked] = useState(false)
    const [isLoading, setIsLoading] = useState(false);
    const [notify, setNotify] = useState("");
    const [count, setCount] = useState(0)
    const [dataVal, setDataVal] = useState([]);
    const [saveModal, setSaveModal] = useState(false);
    const { baseUrl } = useContext(BaseUrl);
    const [savedStatus, setSavedStatus] = useState('');
    const [approvedAmt, setApprovedAmt] = useState(0.0);
    const [holdAmt, setHoldAmt] = useState(0.0);

    const headers = ["Vendor Code",
        "Firm Name",
        "Request Id",
        "Invoice Number",
        "Invoice Amount",
        "Requested Amount",
        "Status",
        "Created by",
        // "Approved by",
        "Requested Date",
        "Action"
    ];


    useEffect(() => {
        if (getVendorPaymentRequestList !== null) {
            (async () => {
                setIsLoading(true);
                await getVendorPaymentRequestList(null, 1, 1);
                setIsLoading(false);
            })();
        }
    }, [getVendorPaymentRequestList]);

    useEffect(() => {
        if (dataList?.data_res) {

            const tableData = ["id",
                "vendor_code",
                "name_of_firm",
                "request_id",
                "invoice_number",
                "total_amount",
                "request_amount",
                "status",
                "created_name",
                // "approved_name",
                "created_at",
                'action'
            ];
            const {data_res} = dataList;
            if (data_res && data_res.length > 0) {
                setDataVal(data_res);
                const data = data_res.map((element) =>
                  Object.assign(
                    {},
                    ...tableData.map((key) => (key === 'action' ?  {
                          ['action']:
                            <input type="checkbox" style={{'display':"block", "margin-left": "15px", "margin-top": "3px"}}
                                   value={element?.id}
                                   onChange={(e) => handleAddRemoveSiteIds(e, element?.id, element?.request_amount)}
                                   required
                            />
                      }:
                      { [key]: element[key] })),
                  ),
                );
                if (data) {
                    setListData(data);
                }
            }
            setApprovedAmt(parseFloat(dataList?.approved_amt));
            setHoldAmt(parseFloat(dataList?.hold_amt))
        }
    }, [dataList]);

    const handleOnSubmitForm = async () => {
        /*if(isAllChecked){
            if(dataVal.length > 0) {
                dataVal.map((element) => {
                    siteIds.push(element?.site_id !== null && element?.site_id !== undefined ? element?.site_id : element?.id)
                })
            }
        }*/
        if (siteIds.length == 0) {
            toast.error('No entry selected');
            return;
        }

        setIsLoading(true)
        const res = await approveHoldRequest(
            {
                'ids':siteIds,
            }
        )
        if (res) {
            if(res.message){
                setSavedStatus(res.message);
            }
            setSaveModal(true);
        }
        setNotify(200)
        setIsLoading(false)
        setCount(count+1)
        // window.location.reload()
    }

    const handleAddRemoveSiteIds = (e, id, amt) => {
        if(e.target.checked){
            siteIds.push(parseInt(id))
            setSiteIds(siteIds)
            setApprovedAmt((approvedAmt) => parseFloat(approvedAmt) + parseFloat(amt));
            setHoldAmt((holdAmt) => parseFloat(holdAmt) - parseFloat(amt));
        } else{
            var index = siteIds.indexOf(parseInt(id));
            if (index !== -1) {
                siteIds.splice(index, 1);
            }
            setApprovedAmt((approvedAmt) => parseFloat(approvedAmt) - parseFloat(amt));
            setHoldAmt((holdAmt) => parseFloat(holdAmt) + parseFloat(amt));
            if (isAllChecked == true) {
                $("input[id='all_check']").prop('checked', false)
            }
            setIsAllChecked(false)
        }
    }

    const makeAllChecked = (e) => {
        if(e.target.checked){
            setIsAllChecked(true)
            $("input[type=checkbox]").prop('checked', true)
            dataVal.map((element) => {
                siteIds.push(element?.site_id !== null && element?.site_id !== undefined ? element?.site_id : element?.id)
            })
            setApprovedAmt((approvedAmt) => parseFloat(approvedAmt) + parseFloat(holdAmt));
            setHoldAmt(0.0);
        }else{
            siteIds.length = 0
            setSiteIds((siteIds) => [])
            setIsAllChecked(false)
            $("input[type=checkbox]").prop('checked', false)
            setApprovedAmt(dataList?.approved_amt);
            setHoldAmt(dataList?.hold_amt)
        }
    }

    const handleSaveModalHide = () => {
        history.push(`${baseUrl}/vendorPaymentRequestApprovalList`);
        setSaveModal(false);
    };

    const headerBtns = () => {
          return (
              <Fragment>
                  <label className={`label label info-label`}>Approved Amt: {approvedAmt}
                  </label>
                  <label className={`label label info-label`}>Hold Amt: {holdAmt}
                  </label>
                <Button
                  onClick={handleOnSubmitForm}
                  // className="filter-hamburger btn btn-primary borderColorBox colorBox filterButton"
                >
                    {localization.submit}
                </Button>
              </Fragment>
            );
    };

    return (
        <Layout
            Buttons={dataVal && dataVal.length > 0 && headerBtns}
            isLoading={isLoading}
            isGoback
        >
        <>
                {/*<div className="row">
                    {newAssigneeRes !== [] && notify !== 200 &&
                        <CustomModal msg={newAssigneeRes?.response?.message} isPageLoad={true}  click={count}/>}
                    {newAssigneeRes !== [] && notify === 200 &&
                        <CustomModal msg={newAssigneeRes?.response?.message}  isPageLoad={true} click={count}/>}
                    <div className="col-md-3 col-sm-12">
                        <DropDownInput
                            label={localization.changeAssignedUser}
                            data={reportee}
                            getIdValue={async (val) => {
                                setNewAssingeeUser(val.id)
                            }}
                        />
                    </div>
                    <center><Button onClick={handleOnSubmitForm}>
                        {localization.ChangeAssignee}
                    </Button>
                    </center>
                </div>*/}
                {dataVal && dataVal.length > 0 ? (
                    <div style={{"overflow":"hidden"}}>
                        <PanelCardWithHeading title={"Hold Payments"}>
                            <>
                                {/*<div>
                                    <p style={{"marginLeft":"86%", "marginBottom":"-21px"}}>Assign All</p>
                                    <input type="checkbox"
                                           value=""
                                           onChange={() => {}}
                                           required
                                           style={{"position":"relative","left":"44%","marginBottom":"29px"}}
                                           onClick={(e) => {makeAllChecked(e)}}
                                           id="all_check"
                                    />
                                </div>*/}

                                <TableSection
                                    data={listData}
                                    isId={false}
                                    headers={headers}
                                    detailList={dataVal}
                                    srNo = {1}
                                />
                            </>
                        </PanelCardWithHeading>
                    </div>
                ) : <h5>{"No data found"}</h5>}
                <Loader isLoading={isLoading} />
        </>
            <ModalPop
              title={localization.success}
              show={saveModal}
              handleModalHide={handleSaveModalHide}
              keyboard
            >
                <div className="text-center">

                    <div className="success">
                        <img src={Images?.tick} alt="" />
                    </div>

                    <h5>{savedStatus}</h5>


                </div>
            </ModalPop>
        </Layout>
    );

};

export default AssignmentForm;
